import type { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import checkBranchStatusSaga from './sagas/check-branch-status';
import createBranchSaga from './sagas/create-branch';
import deleteBranchSaga from './sagas/delete-branch';
import ensureScratchBranchSaga from './sagas/ensure-scratch-branch';
import fetchSchemaSaga from './sagas/fetch-schema';
import fetchServiceLayersSaga from './sagas/fetch-service-layers';
import getBranchListSaga from './sagas/get-branch-list';
import initBranchSaga from './sagas/init-branch';
import mergeBranchSaga from './sagas/merge-branch';
import openBranchMergeSaga from './sagas/open-branch-merge';
import postSchemaSaga from './sagas/post-schema';
import setCurrentBranchSaga from './sagas/set-current-branch';
import updateSchemaSaga from './sagas/update-schema';
import zustandGlueSaga from './sagas/zustand-glue';

export default function* root(): SagaIterator {
  yield all([
    fork(fetchServiceLayersSaga),
    fork(postSchemaSaga),
    fork(fetchSchemaSaga),
    fork(updateSchemaSaga),
    fork(initBranchSaga),
    fork(setCurrentBranchSaga),
    fork(openBranchMergeSaga),
    fork(mergeBranchSaga),
    fork(createBranchSaga),
    fork(deleteBranchSaga),
    fork(getBranchListSaga),
    fork(checkBranchStatusSaga),
    fork(ensureScratchBranchSaga),
    fork(zustandGlueSaga)
  ]);
}
